module.exports = __webpack_public_path__ + "static/media/calculator-result-allow.d7030177.png";